// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type TopSlowQueriesForNewWorkbookQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
  statementTypes:
    | Array<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
}>;

export type TopSlowQueriesForNewWorkbookQuery = {
  __typename?: "GraphqlQuery";
  getQueryStats: Array<{
    __typename?: "QuerySummaryStats";
    id: string;
    truncatedQuery: string;
    normalizedQuery: string;
    avgTime: number;
    callsPerMinute: number;
    pctOfTotal: number;
    sampleCount: number;
  }>;
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    server: {
      __typename?: "Server";
      id: string;
      collectorInfo?: {
        __typename?: "CollectorInfo";
        id: string;
        filterQuerySample?: string | null;
      } | null;
    };
  };
};

export const TopSlowQueriesForNewWorkbookDocument = gql`
  query TopSlowQueriesForNewWorkbook(
    $databaseId: ID!
    $startTs: Int!
    $endTs: Int!
    $statementTypes: [String!]!
    $limit: Int
    $sortBy: String
    $sortDirection: SortDirection
  ) {
    getQueryStats(
      databaseId: $databaseId
      startTs: $startTs
      endTs: $endTs
      statementTypes: $statementTypes
      offset: 0
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      id
      truncatedQuery
      normalizedQuery
      avgTime
      callsPerMinute
      pctOfTotal
      sampleCount
    }
    getDatabaseDetails(databaseId: $databaseId) {
      id
      server {
        id
        collectorInfo {
          id
          filterQuerySample
        }
      }
    }
  }
`;

/**
 * __useTopSlowQueriesForNewWorkbookQuery__
 *
 * To run a query within a React component, call `useTopSlowQueriesForNewWorkbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopSlowQueriesForNewWorkbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopSlowQueriesForNewWorkbookQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *      statementTypes: // value for 'statementTypes'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useTopSlowQueriesForNewWorkbookQuery(
  baseOptions: Apollo.QueryHookOptions<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  > &
    (
      | {
          variables: TopSlowQueriesForNewWorkbookQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  >(TopSlowQueriesForNewWorkbookDocument, options);
}
export function useTopSlowQueriesForNewWorkbookLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  >(TopSlowQueriesForNewWorkbookDocument, options);
}
// @ts-ignore
export function useTopSlowQueriesForNewWorkbookSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TopSlowQueriesForNewWorkbookQuery,
  TopSlowQueriesForNewWorkbookQueryVariables
>;
export function useTopSlowQueriesForNewWorkbookSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TopSlowQueriesForNewWorkbookQuery,
        TopSlowQueriesForNewWorkbookQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TopSlowQueriesForNewWorkbookQuery | undefined,
  TopSlowQueriesForNewWorkbookQueryVariables
>;
export function useTopSlowQueriesForNewWorkbookSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TopSlowQueriesForNewWorkbookQuery,
        TopSlowQueriesForNewWorkbookQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TopSlowQueriesForNewWorkbookQuery,
    TopSlowQueriesForNewWorkbookQueryVariables
  >(TopSlowQueriesForNewWorkbookDocument, options);
}
export type TopSlowQueriesForNewWorkbookQueryHookResult = ReturnType<
  typeof useTopSlowQueriesForNewWorkbookQuery
>;
export type TopSlowQueriesForNewWorkbookLazyQueryHookResult = ReturnType<
  typeof useTopSlowQueriesForNewWorkbookLazyQuery
>;
export type TopSlowQueriesForNewWorkbookSuspenseQueryHookResult = ReturnType<
  typeof useTopSlowQueriesForNewWorkbookSuspenseQuery
>;
export type TopSlowQueriesForNewWorkbookQueryResult = Apollo.QueryResult<
  TopSlowQueriesForNewWorkbookQuery,
  TopSlowQueriesForNewWorkbookQueryVariables
>;
